var config = require("./config");
var utils = require('./utils');
var jsErrorLogger = require("./logger/jsErrorLogger");
var resLogger = require('./logger/resLogger');
var performanceLogger = require('./logger/performanceLogger');

config.domainIgnore=[];

var xlog = {
	config:config,
	utils:utils,
	jsErrorLogger:jsErrorLogger,
	resLogger:resLogger,
	performanceLogger:performanceLogger,
	launch:function(){
		config.init()
		jsErrorLogger.launch()//处理ie9及以下错误
		resLogger.launch()
		performanceLogger.launch()

		if(window.NamedNodeMap){    //IE8及以下不支持
    		utils.addEventHandler(window,"error", function(event){
    			var result = resLogger.handleError(event)
    			if(!result){
    				jsErrorLogger.handleError(event)//这里只处理ie10以上并且script不跨域
    			}
    		},
    		true)
    	}

		utils.onDomReady(function(){
			utils.checkWait()
		})
	}
}
window.xlog = xlog

var selfUrl = utils.getSelfUrl("/xlog")
var sample = utils.getQueryString("sample",selfUrl)
var autoStart = utils.getQueryString("auto",selfUrl)
if(autoStart==0){
	
}else{
	sample = sample?sample:config.sample
	if(utils.willHandle(sample)){
		xlog.launch();
	}
}

module.exports = xlog;


//////////////////
// WEBPACK FOOTER
// ./src/xlog.js
// module id = 2
// module chunks = 0 1 2